"use client";

import "rc-menu/assets/index.css";

import { useState } from "react";
import Menu, { MenuItem, SubMenu } from "rc-menu";
import styles from "./MobileNav.module.scss";
import { DefaultLink } from "./MobileNav";

export function RecursiveRcMenu(props: {
  content: IMenuItem[];
  isSubMenu: boolean;
  [k: string]: any;
}) {
  const { content, isSubMenu, ...restProps } = props;
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  const Component = isSubMenu ? SubMenu : Menu;
  return (
    <Component
      onOpenChange={
        isSubMenu
          ? undefined
          : (keys: string[]) => {
              let nextKeys = keys;
              if (keys.length > 0) {
                const lastOpenedKey = keys[keys.length - 1];
                nextKeys = nextKeys.filter((k) => lastOpenedKey.includes(k));
              }
              setOpenKeys(nextKeys);
            }
      }
      openKeys={isSubMenu ? undefined : openKeys}
      {...restProps}
    >
      {content.map((item) => {
        if (item.content && item.content.length > 0) {
          return (
            <RecursiveRcMenu
              content={item.content}
              isSubMenu={true}
              title={<DefaultLink item={item} />}
              key={item.id}
              className={styles.menuItem}
            />
          );
        } else {
          return (
            <MenuItem key={item.id} className={styles.menuItem}>
              <DefaultLink item={item} />
            </MenuItem>
          );
        }
      })}
    </Component>
  );
}
